<div class="maxContainer hidden  lg:block  px-10 py-[5px]" >
  <div class="my-10 cards bg-white flex flex-col justify-center outline" [ngClass]="{'outline': outlineActive}">
   
    <div class="card-item min-h-[100dvh] flex justify-between sm:w-auto mt-10" *ngFor="let slide of sliderData; let i = index;">
      <div class="flex flex-col  gap-4 ">
 <div class="heading " *ngIf="slide.heading">
      <h4 class="text-gradient">Instant upfront payments</h4>
      <h2>How Upfront <br> Payments Work</h2>
    </div>

        <div class="relative">
          <p class="custom-border font-normal leading-[28px] " [ngClass]="{'max-w-[280px] top-[7%]': i === 0, 'max-w-[280px] top-[150%]': i === 1, 'max-w-[280px] top-[249%]': i === 2}">
            {{slide.text}}
          </p>
          <span class="absolute w-[2px] rounded-full p-2 bg-[--sec-clr]" [ngClass]="{' top-[11%]': i === 0, ' top-[152%]': i === 1, 'top-[251%]': i === 2}"></span>
        </div>
      </div>
      <div class="imgContainer">
        <img src="assets/images/payment-gateway/{{slide.imageURL}}" 
             class="lg:w-[844px] w-[400px] items-start" alt="">
      </div>
    </div>
  </div>
</div>

<div class="maxContainer px-4 md:px-10 md:py-[5px]   lg:hidden block ">
  <div class="my-5 cards bg-white flex flex-col justify-center outline" [ngClass]="{'outline': outlineActive}">
    <div class="card-items  flex lg:flex-row flex-col justify-between sm:w-auto mt-10" *ngFor="let slide of sliderData; let i = index;">
      <div class="flex flex-col lg:flex-row gap-4 bg-white md:bg-transparent	relative">
        <div class="heading" *ngIf="slide.heading">
          <h4 class="text-gradient">Instant upfront payments</h4>
          <h2>How Upfront <br> Payments Work</h2>
        </div>
        <div class="imgContainer md:mt-0 bg-white !md:bg-transparent flex flex-col justify-center card-item 	">
         <div class="flex flex-col gap-4 bg-span py-3">
           <p class="block lg:hidden custom-border text-[16px] font-normal leading-[28px] relative" >
            {{slide.text}}
          </p>
          <span class="block lg:hidden absolute w-[1.5px] lg:w-[2px] rounded-full p-1 lg:p-2 bg-[--sec-clr] mt-5" ></span>
        </div>
          <img src="assets/images/payment-gateway/{{slide.imageURL}}" class="lg:w-[844px] items-start" alt="">
      </div>
    </div>
  </div>
</div>
